import { WeekdayToggle } from '@/domain/termine/components/WeekdayToggle';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import dayjs from 'dayjs';

export function WeekdaySelectFormField() {
  const { form } = useCreateTermineFormContext();

  return (
    <form.Subscribe selector={(state) => state.values.datum}>
      {(datum) => (
        <form.Field name="wochentagAuswahl">
          {(field) => (
            <WeekdayToggle
              date={dayjs(datum)}
              value={field.state.value ?? []}
              onChange={field.handleChange}
            />
          )}
        </form.Field>
      )}
    </form.Subscribe>
  );
}
